import { Component, OnInit, EventEmitter, ViewChild, Output } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Option } from '../../../domain/select/option';
import { SingleoptionSinBindingComponent } from '../../selects/singleoption/singleoption.component';
import { ToastrService } from 'ngx-toastr';
import { FormService } from '../../../services/formServices';
import { Router } from '@angular/router';

@Component({
  selector: 'app-solicitudinformacion',
  templateUrl: './solicitudinformacion.component.html',
  styleUrls: ['./solicitudinformacion.component.scss']
})
export class SolicitudinformacionComponent implements OnInit {
  @Output('form') formComplete = new EventEmitter<boolean>();
  @ViewChild('perfil') perfil: SingleoptionSinBindingComponent;
  validation_messages
  formFisica: FormGroup;
  formJuridica: FormGroup;
  listTemas: Option;
  listTipoDocumentos: Option;
  enviando = false;
  persona: string;
  // arrayForm = new Array("persona", "nombre", "apellido", "tipoDocumento", "documento", "adjuntos", "telefono", "email", "tema", 'pedido');
  arrayForm = new Array("persona", "nombre", "apellido", "tipoDocumento", "documento", "telefono", "email", "tema", 'pedido', 'domicilio','localidad','provincia','cp','pais');
  arrayFormJuridica = new Array("persona", "razonSocial", "cuit", "telefono", "email", "tema", 'pedido', 'domicilio','localidad','provincia','cp','pais');

  constructor(private formService: FormService, private toaster: ToastrService, private router: Router) { }

  ngOnInit() {
    this.persona = null;
    this.formService.getTemas().subscribe(data => this.listTemas = data);
    this.formService.getTipoDocumentos().subscribe(data => this.listTipoDocumentos = data);
    this.validation_messages = {
      "persona": [
        { "type": "required", "message": "Debe seleciconar tipo de persona" }
      ],
      "nombre": [
        { "type": "required", "message": "Debe ingresar el nombre del usuario" }
      ],
      "apellido": [
        { "type": "required", "message": "Debe ingresar el apellido del usuario" }
      ],
      "tipoDocumento": [
        { "type": "required", "message": "Debe seleccionar el tipo de documento" }
      ],
      "documento": [
        { "type": "required", "message": "Debe ingresar el documento del usuario" },
        { "type": "pattern", "message": "Solo se aceptan números, sin puntos ni otros caracteres no numericos" }
      ],
      // "adjuntos": [
      //   { "type": "required", "message": "Debe cargar una foto" }
      // ],
      "telefono": [
        { "type": "required", "message": "Debe ingresar un número de télefono" },
        { "type": "pattern", "message": "Debe cumplir con formato código de país (+54) código de área (11) y número local (12345678)" }
      ],
      "email": [
        { "type": "required", "message": "Debe ingresar un correo electronico valido perteneciente al usuario" },
        { "type": "email", "message": "Debe cumplir con formato ejemplo@email.com" }
      ],
      "razonSocial": [
        { "type": "required", "message": "Debe especificar Razón Social" }
      ],
      "cuit": [
        { "type": "required", "message": "Debe ingresar el cuit del usuario" },
        { "type": "pattern", "message": "Solo se aceptan números, sin puntos ni otros caracteres no numericos" }
      ],
      "tema": [
        { "type": "required", "message": "Debe seleccionar el tema" }
      ],
      "domicilio": [
        { "type": "required", "message": "Debe ingresar el domicilio" }
      ],
      "localidad": [
        { "type": "required", "message": "Debe ingresar la localidad" }
      ],
      "provincia": [
        { "type": "required", "message": "Debe ingresar la provincia" }
      ],
      "cp": [
        { "type": "required", "message": "Debe ingresar el código postal" }
      ],
      "pais": [
        { "type": "required", "message": "Debe ingresar el país" }
      ]
    }
    this.formFisica = new FormGroup({
      persona: new FormControl(null, Validators.compose([Validators.required])),
      nombre: new FormControl(null, Validators.compose([Validators.required])),
      apellido: new FormControl(null, Validators.compose([Validators.required])),
      tipoDocumento: new FormControl(null, Validators.compose([Validators.required])),
      documento: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$')]),
      // adjuntos: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$')]),
      telefono: new FormControl(null, Validators.compose([Validators.required, Validators.pattern("^[+][0-9]{12,100}$")])),
      email: new FormControl(null, Validators.compose([Validators.required, Validators.email])),
      tema: new FormControl(null, Validators.compose([Validators.required])),
      pedido: new FormControl(null,Validators.compose([Validators.required])),
      domicilio: new FormControl(null, Validators.compose([Validators.required])),
      localidad: new FormControl(null, Validators.compose([Validators.required])),
      provincia: new FormControl(null, Validators.compose([Validators.required])),
      cp: new FormControl(null, Validators.compose([Validators.required])),
      pais: new FormControl(null, Validators.compose([Validators.required])),
    }, { updateOn: 'blur' });

    this.formJuridica = new FormGroup({
      persona: new FormControl(null, Validators.compose([Validators.required])),
      telefono: new FormControl(null, Validators.compose([Validators.required, Validators.pattern("^[+][0-9]{12,100}$")])),
      email: new FormControl(null, Validators.compose([Validators.required, Validators.email])),
      razonSocial: new FormControl(null),
      cuit: new FormControl(null),
      tema: new FormControl(null, Validators.compose([Validators.required])),
      pedido: new FormControl(null,Validators.compose([Validators.required])),
      domicilio: new FormControl(null, Validators.compose([Validators.required])),
      localidad: new FormControl(null, Validators.compose([Validators.required])),
      provincia: new FormControl(null, Validators.compose([Validators.required])),
      cp: new FormControl(null, Validators.compose([Validators.required])),
      pais: new FormControl(null, Validators.compose([Validators.required])),
    }, { updateOn: 'blur' });
  }

  setTipoDocumento(value) {
    this.formFisica.patchValue({
      tipoDocumento: value.id
    });
  }

  // actualizarAdjunto(idAdjunto) {
  //   this.formFisica.patchValue({
  //     adjuntos: idAdjunto[0]
  //   });
  // }

  setPersona(value) {
    if (value == 'fisica' && value != undefined) {
      this.formJuridica.reset();
      this.persona = value;
      this.formFisica.patchValue({
        persona: value
      });
    }
    if (value == 'juridica' && value != undefined) {
      this.formFisica.reset();
      this.persona = value;
      this.formJuridica.patchValue({
        persona: value
      });
    }

  }


  setTema(value) {
    if (this.persona == 'fisica' && value != undefined) {
      this.formFisica.patchValue({
        tema: value.id
      });
    }
    if (this.persona == 'juridica' && value != undefined) {
      this.formJuridica.patchValue({
        tema: value.id
      });
    }
  }


  saveForm() {
    let form;
    if (this.persona == 'fisica') {
      form = this.formFisica;
      this.arrayForm.map(item => {
      });

      // Aca se chequea si el form tiene adjuntos
      // if (this.persona == 'fisica' && this.formFisica.value.adjuntos == null) {
      //   this.toaster.error('Falta guardar adjunto agregado', 'Error');
      //   return false;
      // }

    }


    if (this.persona == 'juridica') {
      form = this.formJuridica;
      this.arrayFormJuridica.map(item => {
      });
    }


    if (form.valid) {
      this.enviando = true;
      let response;
      if (this.persona == 'fisica') {
        response = this.formService.setSolicitudInformacionFisico(form.value).subscribe(data => { this.enviando = false; return data; });
      }
      if (this.persona == 'juridica') {
        response = this.formService.setSolicitudInformacionJuridico(form.value).subscribe(data => { this.enviando = false; return data; });
      }
      this.toaster.success('Formulario guardado correctamente', 'Exito!');
      this.router.navigateByUrl('form/finalizado');
      return response;
    } else {
      this.toaster.error('Faltan completar campos para poder finalizar el formulario', 'Error');
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/form/solicitudinformacion/solicitudinformacion.component.ts